'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'image';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f03e';
var svgPathData = 'M416 64l0 384-384 0 0-384 384 0zM32 32l-32 0 0 448 448 0 0-448-416 0zM143.3 267.8L64 400 384 400 365.7 368 273.9 207.3 256 176c-29 45.1-54.8 85.2-60.3 93.8-15.7-13.1-32.3-26.9-35.7-29.8l-16.7 27.8zm24.9 20.7c1.2 1 12.8 10.7 34.8 29 11-17.2 28.1-43.8 51.3-79.9l74.5 130.3-208.3 0 47.7-79.5zM144 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;